import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

const SkeletonItem = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh", // Точная высота для полноэкранного режима
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        scrollSnapAlign: "start",
        scrollSnapStop: "always",
        flexShrink: 0,
        position: "relative",
        // Убираем margin для точной навигации в полноэкранном режиме
      }}
    >
      <Box
        sx={{
          width: { xs: "85vw", sm: "85vw", md: "400px" },
          maxWidth: "400px",
          position: "relative",
        }}
      >
        {/* Контейнер видео с правильными пропорциями */}
        <Box
          sx={{
            position: "relative",
            height: 0,
            width: "100%",
            paddingTop: "177.78%", // 9:16 соотношение
            overflow: "hidden",
          }}
        >
          {/* Фон скелетона */}
          <Skeleton
            variant="rectangular"
            sx={{
              position: "absolute",
              height: "100%",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: 2,
              bgcolor: "rgba(255, 255, 255, 0.1)", // Для темной темы
            }}
          />

          {/* Имитация заголовка и описания внизу */}
          <Box
            sx={{
              position: "absolute",
              bottom: 8,
              left: 8,
              right: 8,
            }}
          >
            {/* Заголовок */}
            <Skeleton
              variant="text"
              width="85%"
              height={28}
              sx={{
                mb: 0.5,
                bgcolor: "rgba(255, 255, 255, 0.15)",
              }}
            />
            {/* Описание */}
            <Skeleton
              variant="text"
              width="65%"
              height={20}
              sx={{ bgcolor: "rgba(255, 255, 255, 0.12)" }}
            />
          </Box>

          {/* Имитация прогресс бара */}
          <Box
            sx={{
              position: "absolute",
              bottom: -8,
              left: 0,
              right: 0,
              px: 1,
            }}
          >
            <Skeleton
              variant="rectangular"
              height={4}
              sx={{
                borderRadius: 2,
                bgcolor: "rgba(255, 255, 255, 0.1)",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default function ShortyLoadingSkeleton({ count = 2 }) {
  return (
    <Box
      sx={{
        height: "100vh", // Полноэкранный режим
        width: "100%",
        overflowY: "auto",
        scrollSnapType: "y mandatory",
        scrollBehavior: "smooth",
        position: "relative",
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonItem key={index} />
      ))}
    </Box>
  );
}

ShortyLoadingSkeleton.propTypes = {
  count: PropTypes.number,
};
